/**
 * AI widget settings in Widget.query JSON (__aiConfig), mirrored on the backend.
 */
import { DEFAULT_OUTPUT_MODE } from '../constants/outputModes';
import { DEFAULT_PROMPT_TYPE } from '../constants/promptTypes';

const VALID_OUTPUT_MODES = new Set(['precise', 'elaborate', 'formal']);
const VALID_PROMPT_TYPES = new Set(['free_text', 'ratings', 'workplace_experience']);

export function parseAiWidgetConfig(query) {
  const out = {
    outputMode: DEFAULT_OUTPUT_MODE,
    promptType: DEFAULT_PROMPT_TYPE,
  };
  if (!query || typeof query !== 'string' || !query.trim().startsWith('{')) {
    return out;
  }
  try {
    const meta = JSON.parse(query);
    const cfg = meta?.__aiConfig;
    if (!cfg || typeof cfg !== 'object') return out;
    if (cfg.outputMode && VALID_OUTPUT_MODES.has(cfg.outputMode)) {
      out.outputMode = cfg.outputMode;
    }
    if (cfg.promptType && VALID_PROMPT_TYPES.has(cfg.promptType)) {
      out.promptType = cfg.promptType;
    }
  } catch {
    /* ignore */
  }
  return out;
}

export function mergeAiConfigIntoQuery(query, { outputMode, promptType } = {}) {
  let base = {};
  if (query && typeof query === 'string' && query.trim().startsWith('{')) {
    try {
      const parsed = JSON.parse(query);
      if (parsed && typeof parsed === 'object') base = { ...parsed };
    } catch {
      base = {};
    }
  }
  const cfg = { ...(base.__aiConfig || {}) };
  if (outputMode && VALID_OUTPUT_MODES.has(outputMode)) cfg.outputMode = outputMode;
  if (promptType && VALID_PROMPT_TYPES.has(promptType)) cfg.promptType = promptType;
  base.__aiConfig = cfg;
  return JSON.stringify(base);
}
